import React from "react";
import BtnCreateNewLeave from "./top.content.btn.create";
import BtnRequestCompensation from "./top.content.btn.request.compensation";
import "./top.content.css";

export default function TopContent({ data }) {
  const userLeave = data.user_leave;
  let isHideSubtext = false;
  if (
    userLeave?.annual_leave_days?.hours === 0 &&
    userLeave?.previous_year_balance?.hours === 0 &&
    userLeave?.leave_days_balance?.hours === 0 &&
    userLeave.compensation_days_balance.hours === 0
  ) {
    isHideSubtext = true;
  }
  return (
    <div className="leave-summary-container" id="top-content">
      <div className="leave-summary-dashboard">
        {/* Annual Leave Entitlement */}
        <div className="leave-summary-card">
          <div className="leave-summary-circle brown"></div>
          <div className="leave-summary-line"></div>
          <h2 className="leave-summary-title">Annual Leave Entitlement</h2>
          <p className="leave-summary-days">
            {userLeave?.annual_left_days?.days ?? 0} day
            {userLeave?.annual_left_days?.days > 1 && "s"}
          </p>
          <p className="leave-summary-subtext">
            {!isHideSubtext &&
              userLeave?.annual_left_days?.hours > 0 &&
              `+ ${userLeave.annual_left_days.hours} hour` +
                (userLeave.annual_left_days.hours > 0 ? "s" : "")}
            {!isHideSubtext && userLeave?.annual_left_days?.hours <= 0 && (
              <>&nbsp;</>
            )}
          </p>
          <p className="leave-summary-highlight text-brown">
            Total Entitlement :&nbsp;
            {userLeave.days_entitled.days} day
            {userLeave.days_entitled.days > 1 && "s"}
            {userLeave.days_entitled.hours > 0 &&
              " " +
                userLeave.days_entitled.hours +
                " hour" +
                (userLeave.days_entitled.hours > 1 && "s")}
          </p>
        </div>

        {/* Carryover from last year */}
        <div className="leave-summary-card">
          <div className="leave-summary-circle yellow"></div>
          <div className="leave-summary-line"></div>
          <h2 className="leave-summary-title">Carryover from last year</h2>
          <p className="leave-summary-days">
            {userLeave?.previous_year_left_days?.days ?? 0} day
            {userLeave?.previous_year_left_days?.days > 1 && "s"}
          </p>
          <p className="leave-summary-subtext">
            {!isHideSubtext &&
              userLeave?.previous_year_left_days?.hours > 0 &&
              `+ ${userLeave.previous_year_left_days.hours} hour` +
                (userLeave.previous_year_left_days.hours > 0 ? "s" : "")}
            {!isHideSubtext &&
              userLeave?.previous_year_left_days?.hours <= 0 && <>&nbsp;</>}
          </p>
          <p className="leave-summary-highlight text-yellow">
            Carryover :&nbsp;
            {userLeave.previous_year_balance.days} day
            {userLeave.previous_year_balance.days > 1 && "s"}
            {userLeave.previous_year_balance.hours > 0 &&
              " " +
                userLeave.previous_year_balance.hours +
                " hour" +
                (userLeave.previous_year_balance.hours > 1 && "s")}
          </p>
        </div>

        {/* Available Leave Balance */}
        <div className="leave-summary-card">
          <div className="leave-summary-circle green"></div>
          <div className="leave-summary-line"></div>
          <h2 className="leave-summary-title">Available Leave Balance</h2>
          <p className="leave-summary-days">
            {userLeave?.leave_days_balance?.days ?? 0} day
            {userLeave?.leave_days_balance?.days > 1 && "s"}
          </p>
          <p className="leave-summary-subtext">
            {!isHideSubtext &&
              userLeave?.leave_days_balance?.hours > 0 &&
              `+ ${userLeave.leave_days_balance.hours} hour` +
                (userLeave.leave_days_balance.hours > 0 ? "s" : "")}
            {!isHideSubtext && userLeave?.leave_days_balance?.hours <= 0 && (
              <>&nbsp;</>
            )}
          </p>
          <p className="leave-summary-highlight">
            <span className="text-green">To Book Time Off</span>
            <span className="text-gray" style={{ marginLeft: "10px" }}>
              Pro-rated: {userLeave?.pro_rata_days_balance?.days ?? 0} day
              {userLeave?.pro_rata_days_balance?.days > 1 && "s"}
            </span>
          </p>
        </div>

        {/* Compensatory Days */}
        <div className="leave-summary-card">
          <div className="leave-summary-circle light-gray"></div>
          <h2 className="leave-summary-title">Compensatory Days</h2>
          <p className="leave-summary-days">
            {userLeave?.compensation_days_balance?.days ?? 0} day
            {userLeave?.compensation_days_balance?.days > 1 && "s"}
          </p>
          <p className="leave-summary-subtext">
            {!isHideSubtext &&
              userLeave?.compensation_days_balance?.hours > 0 &&
              `+ ${userLeave.compensation_days_balance.hours} hour` +
                (userLeave.compensation_days_balance.hours > 0 ? "s" : "")}
            {!isHideSubtext &&
              userLeave?.compensation_days_balance?.hours <= 0 && <>&nbsp;</>}
          </p>
        </div>
      </div>
      {/* Description */}
      <div className="leave-summary-desc">
        <div className="leave-summary-desc-text">
          *Unused balance carries over.
        </div>
        <div className="leave-summary-desc-text text-red">
          *Expires: {userLeave.expiry_date}
        </div>
        <div className="leave-summary-desc-text">
          *Includes carryover and current entitlement.
        </div>
        <div className="leave-summary-desc-text">
          *Earned for overtime or work on holidays. Valid for 6 months from
          approval, unused leave will lapse.
        </div>
      </div>
      {/* Bottom */}
      <div className="leave-summary-bottom">
        <div>
          <span className="title">Your Approver is</span>
          <span>{data.eleave_approver_name}</span>
        </div>
        <div>
          <span className="title">Your Co-Approver is</span>
          <span>{data.eleave_co_approver_name}</span>
        </div>
        <BtnRequestCompensation />
        <BtnCreateNewLeave />
      </div>
    </div>
  );
}
